














import { Component, Prop, Vue } from "vue-property-decorator";
import { default as Profile } from "./Profile.vue";
import { default as ExperienceAndSkills } from "./ExperienceAndSkills.vue";
import { default as AllExistence } from "./AllExistence/AllExistence.vue";
import { default as Archive } from "./Archive.vue";
import { default as Contact } from "./Contact.vue";

@Component({
	components: {
		Profile,
		ExperienceAndSkills,
		AllExistence,
		Archive,
		Contact
	}
})
export default class Page extends Vue {}
